
import { name } from './name.js';

export function define(Ctor) {
  customElements.define(Ctor.is || name(), Ctor);
  return Ctor;
}